import {deviceType,actionType,messageType} from '@/utils/socket/socket_constant.js'
import { get, post } from '@/utils/request';
// 封装连接服务器
function serverConnection(msgObj) {
	let obj = {
		"actionType": actionType.REQUESTMSG,
		"deviceType": deviceType.PC,
		"message": {
			"messageType": messageType.CONNECT,
			"senderId": msgObj.senderId,
			"message": msgObj.token
		}
	}
	obj = JSON.stringify(obj)
	return obj
}
// 心跳
function heartBeat(msgObj) {
	let obj = {
		"actionType": actionType.REQUESTMSG,
		"deviceType": deviceType.PC,
		"message": {
			"messageType": messageType.HEARTBEAT,
			"senderId": msgObj.senderId
		}
	}
	obj = JSON.stringify(obj)
	return obj
}
// 私聊消息
function privateChat(msgObj) {
	let obj = {
		actionType: actionType.FRIENDMSG,
		deviceType: deviceType.PC,
		message: {
			messageType: messageType.TEXT,
			senderId: msgObj.senderId,
			receiverId: msgObj.receiverId,
			message: msgObj.message,
			messageId: msgObj.messageId,
		},

	}
	obj = JSON.stringify(obj)
	return obj;
}
//封装图片消息
function packImageMessage(msgObj) {
	var obj = {
		actionType: actionType.FRIENDMSG,
		deviceType: deviceType.PC,
		message: {
			messageType: messageType.IMAGE,
			senderId: msgObj.senderId,
			receiverId: msgObj.receiverId,
			message: msgObj.message,
			messageId: msgObj.messageId,
		},

	}
	obj = JSON.stringify(obj)
	return obj;
}
// 封装签收成功消息
function signed(msgObj) {
	let obj = {
		actionType: actionType.FRIENDMSG,
		deviceType: deviceType.PC,
		message: {
			messageType: messageType.MSGSIGNED,
			senderId: msgObj.senderId,
			receiverId: msgObj.receiverId,
			message: msgObj.message,
			messageId: msgObj.messageId,
		},
	}
	obj = JSON.stringify(obj)
	return obj;
}
export default {
	serverConnection,
	heartBeat,
	privateChat,
	packImageMessage,
	signed
};